<ion-header>

  <ion-toolbar [ngClass]="{'empty-title': !title}">

    <ion-title>{{ title }}</ion-title>

    <ion-buttons slot="end">
      <yu-button type="clear" color="dark" (yuClick)="dismiss()">
        <yu-icon name="x"></yu-icon>
      </yu-button>
    </ion-buttons>

  </ion-toolbar>

</ion-header>

<ion-content class="selector-list" [scrollY]="groupItems">

  @if (!groupItems) {

    <cdk-virtual-scroll-viewport
      class="ion-content-scroll-host"
      minBufferPx="900"
      maxBufferPx="1350"
      [itemSize]="!itemsImageField ? 60 : 75"
    >

      <yu-searchbar [placeholder]="searchText | translate" [(value)]="searchValue"></yu-searchbar>

      <ion-list lines="none">

        <ion-item
          *cdkVirtualFor="let item of itemsToList | search: searchValue: itemsLabelField"
          [ngClass]="{'item-checked': item.is_checked}"
        >
          @if (!!itemsImageField) {
            <ion-thumbnail slot="start">
              <img [src]="item[itemsImageField] || 'assets/img/empty-img/no_image.png'" alt="--">
            </ion-thumbnail>
          }

          <yu-checkbox
            justify="space-between"
            [(value)]="item.is_checked"
            (valueChange)="doCheckAction(item)"
          >
            <div class="ion-text-wrap">{{ item[itemsLabelField] | translate }}</div>

            @if (item[itemsDescriptionField]) {
              <div class="description">{{ item[itemsDescriptionField] | translate }}</div>
            }
          </yu-checkbox>
        </ion-item>

        @if ((itemsToList | search: searchValue: itemsLabelField)?.length === 0) {
          <app-empty-item
            icon="magnifying-glass"
            [title]="'COMMON.NO_RESULTS' | translate"
          ></app-empty-item>
        }

      </ion-list>

    </cdk-virtual-scroll-viewport>

  } @else {

    <yu-searchbar [placeholder]="searchText | translate" [(value)]="searchValue"></yu-searchbar>

    @for (itemGroup of itemsGroupToList; track itemGroup) {

      @if ((itemGroup.items | search: searchValue: itemsLabelField).length > 0) {

        <ion-list lines="none">

          <ion-list-header>
            <ion-label>{{ itemGroup.text | translate }}</ion-label>
          </ion-list-header>

          @for (item of itemGroup.items | search: searchValue: itemsLabelField; track item) {

            <ion-item [ngClass]="{'item-checked': item.is_checked}">

              @if (!!itemsImageField) {
                <ion-thumbnail slot="start">
                  <img [src]="item[itemsImageField] || 'assets/img/empty-img/no_image.png'" alt="--">
                </ion-thumbnail>
              }

              <yu-checkbox
                justify="space-between"
                [(value)]="item.is_checked"
                (valueChange)="doCheckAction(item)"
              >
                <div class="ion-text-wrap">{{ item[itemsLabelField] | translate }}</div>

                @if (item[itemsDescriptionField]) {
                  <div class="description">{{ item[itemsDescriptionField] | translate }}</div>
                }
              </yu-checkbox>
            </ion-item>

          }

        </ion-list>

      }

    } @empty {

      <app-empty-item
        icon="magnifying-glass"
        [title]="'COMMON.NO_RESULTS' | translate"
      ></app-empty-item>

    }

  }

</ion-content>

@if (multiple) {
  <ion-footer>
    <ion-toolbar>
      <yu-button
        color="gradient"
        expand="block"
        (yuClick)="dismiss(value)"
      >
        {{ 'COMMON.SAVE' | translate }}
      </yu-button>
    </ion-toolbar>
  </ion-footer>
}
